import { Container, Grid } from "@mui/material";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";
import {
  StyledContent,
  StyledGridContainer,
  StyledTitle,
} from "@Styled/Pages/Prefooter";

const TermsAndCondition = () => {
  return (
    <>
      <Container sx={{ marginBottom: "5rem" }}>
        <StyledGridContainer container>
          <StyledHeadingWithGradientunderline
            variant="subtitle1"
            sx={{
              fontSize: { sm: "1.5rem", xs: "1.2rem" },
              letterSpacing: "-1px",
            }}
          >
            Privacy Policy{" "}
          </StyledHeadingWithGradientunderline>
        </StyledGridContainer>
        <StyledContent
          style={{
            fontWeight: "bold",
            fontSize: "1.5rem",
            padding: "1rem 1rem",
          }}
        >
          Econut India Private Limited privacy policy for databases collected
          from internet / customers / consumers.
        </StyledContent>
        <StyledContent>
          Econut India Private Limited (Econut.store) respects your privacy, and
          the privacy of all visitors to its web site. It is the company’s
          policy to collect personally identifiable information (such as names,
          addresses, telephone / fax numbers, or email addresses) only when
          visitors voluntarily submit such information. This information will be
          kept strictly confidential and will not be sold, reused, rented,
          loaned or otherwise disclosed. We use this information only to answer
          any of your requests for information, or to better understand your
          needs.
        </StyledContent>
        <StyledTitle>Tracking Technology</StyledTitle>
        <StyledContent>
          {" "}
          Econut does not make use of tracking technology (cookies) on its site.
          Cookies are small text files that are sent by a web site, accepted by
          a web browser and then placed on your hard drive. Some web sites use
          cookies to collect data that help provide information regarding the
          functionality of the site or to help analyze browsing patterns and use
          of the site.
        </StyledContent>
        <StyledTitle>Children</StyledTitle>
        <StyledContent>
          {" "}
          This website is not intended or designed to attract children under the
          age of 18. Econut does not collect personally identifiable data from
          any person we know to be under the age of 18.
        </StyledContent>
        <StyledTitle>Policy Revisions </StyledTitle>
        <StyledContent>
          {" "}
          ECONUT reserves the right to change, modify, add, or remove portions
          of this Policy at any time and at our discretion. If we change our
          Privacy Policy, we will post those changes on this page so that you
          may become aware of what information we may collect, how we may use it
          and under what circumstances we may disclose it. You should visit this
          page from time to time to review the then-current policy because it is
          binding on you.
        </StyledContent>
        <StyledTitle>Third-Party Sites </StyledTitle>
        <StyledContent>
          {" "}
          Links from the Econut.store website if take you to sites not covered
          by this Privacy Policy. We advise you to check the applicable privacy
          practices for those third-party sites yourself.
        </StyledContent>
      </Container>
    </>
  );
};
export default TermsAndCondition;
